var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.79 0.570007H6.50999C2.99746 0.570007 0.149994 3.41748 0.149994 6.93001V41.21C0.149994 44.7225 2.99746 47.57 6.50999 47.57H63.79C67.3025 47.57 70.15 44.7225 70.15 41.21V6.93001C70.15 3.41748 67.3025 0.570007 63.79 0.570007Z",
    fill: "#006A4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.65 36.57C42.5536 36.57 48.15 30.9736 48.15 24.07C48.15 17.1664 42.5536 11.57 35.65 11.57C28.7464 11.57 23.15 17.1664 23.15 24.07C23.15 30.9736 28.7464 36.57 35.65 36.57Z",
    fill: "#F42A41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgd);
export default __webpack_public_path__ + "static/media/BGD.499867c2765eb225645c45c75be68b03.svg";
export { ForwardRef as ReactComponent };